import { atom } from 'recoil';

const email = atom({
  key: 'email',
  default: '',
});

export default email;
